import { configureStore } from '@reduxjs/toolkit';
import tasksReducer from './slices/tasksSlice';
import bidsReducer from './slices/bidsSlice';

export const store = configureStore({
  reducer: {
    tasks: tasksReducer,
    bids: bidsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store; 